import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { SECTOR_API_PATH } from "@/modules/Sector/constants";
import { SectorProductivityParamsRequestModel } from "../models/FetchSectorProductivityParams.request";
import { formatString } from "@/core/utils/helpers";

class SectorService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public getAll(): Promise<ICoreResponse> {
    return this.restClient.get(SECTOR_API_PATH.GET_ALL);
  }

  public getSectorStats(sectorId: string): Promise<ICoreResponse> {
    return this.restClient.get(
      formatString(SECTOR_API_PATH.GET_SECTOR_USAGE_SNAPSHOT, sectorId),
    );
  }

  public getSectorProductivity(
    sectorId: string,
    payload: SectorProductivityParamsRequestModel,
  ): Promise<ICoreResponse> {
    return this.restClient.get(
      formatString(SECTOR_API_PATH.GET_SECTOR_PRODUCTIVITY, sectorId),
      payload,
    );
  }
}

export default SectorService;
